import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import {
	MarkdownRender,
	UseCommunicationDataEmail,
	UseCommunicationDataPhone,
} from '@gov-nx/component/web';
import type { ComplaintsForm } from '@gov-nx/module/page';
import { useRezaLocale } from '@gov-nx/module/page';
import { Button, Dialog, FormInput, LayoutGap } from '@gov-nx/ui/web';

interface Props {
	complaintsForm: ComplaintsForm;
}

export const ComplaintsModal = ({ complaintsForm }: Props) => {
	const { t } = useRezaLocale();
	const { isModalOpen, onSubmit, fields, formDefinition } = complaintsForm;

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<Dialog
				isOpen={isModalOpen.isTrue}
				onClose={isModalOpen.setFalse}
				title={<h3>{t('complaints.title')}</h3>}
				footer={
					<Button
						color="primary"
						type="solid"
						size="m"
						nativeType="submit"
						{...fields.submit}>
						{fields.submit.children}
					</Button>
				}>
				<LayoutGap>
					<MarkdownRender>{t('complaints.description')}</MarkdownRender>

					<FormInput {...fields.complaint} />

					<UseCommunicationDataEmail
						personCommunicationData={complaintsForm.personCommunicationData}
						fields={complaintsForm.fields}
						email={complaintsForm.formDefinition.formMethods.watch('email')}
						onReset={() =>
							complaintsForm.formDefinition.formMethods.resetField('email')
						}
						wcagLabels={{ edit: 'edit', cancel: 'cancel' }}
					/>
					<UseCommunicationDataPhone
						personCommunicationData={complaintsForm.personCommunicationData}
						fields={complaintsForm.fields}
						phone={complaintsForm.formDefinition.formMethods.watch('phone')}
						onReset={() =>
							complaintsForm.formDefinition.formMethods.resetField('phone')
						}
						wcagLabels={{ edit: 'edit', cancel: 'cancel' }}
					/>
				</LayoutGap>
			</Dialog>
		</GovFormWeb>
	);
};
